import script from "./MediaLocationTagger.vue?vue&type=script&lang=ts&setup=true"
export * from "./MediaLocationTagger.vue?vue&type=script&lang=ts&setup=true"

import "./MediaLocationTagger.vue?vue&type=style&index=0&id=695bf122&lang=css"

const __exports__ = script;

export default __exports__